












import Vue from "vue";

export default Vue.extend({
  props: {
    textParam: {
      type: Object,
      default: Object,
    },
    textKey: {
      type: String,
      default: String,
    },
    textIndex: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      ParamJson: Object,
      textbox: true,
    };
  },
  watch: {
    textParam: {
      handler() {
        this.ParamJson = this.textParam[this.textKey][this.textIndex];
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.ParamJson = this.textParam[this.textKey][this.textIndex];
    this.reload();
  },
  methods: {
    ChangeText() {
      if (this.textIndex === 0) {
        this.textParam[this.textKey] = [
          this.ParamJson,
          this.textParam[this.textKey][1],
          this.textParam[this.textKey][2],
        ];
      }
      if (this.textIndex === 1) {
        this.textParam[this.textKey] = [
          this.textParam[this.textKey][0],
          this.ParamJson,
          this.textParam[this.textKey][2],
        ];
      }
      if (this.textIndex === 2) {
        this.textParam[this.textKey] = [
          this.textParam[this.textKey][0],
          this.textParam[this.textKey][1],
          this.ParamJson,
        ];
      }
    },
    reload() {
      if (this.textParam.header === true) {
        this.textbox = false;
      }
      if (this.textParam.header === false) {
        this.textbox = true;
      }
    },
  },
});
